import { LocalDate } from '../../_shared/domain/local-date';

export function getBodyAppointmentYear(bodyAppointmentDate: string): string {
  return bodyAppointmentDate.split('-')[0];
}

export function getCurrentYear(): string {
  return new LocalDate().getYearStr();
}
